// extracted by mini-css-extract-plugin
export default {"loader":"QvVUF","stub":"fxEgq","grid":"Gzayy"};